import { render, staticRenderFns } from "./Common.vue?vue&type=template&id=6db836fe"
import script from "./Common.vue?vue&type=script&lang=ts"
export * from "./Common.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6db836fe')) {
      api.createRecord('6db836fe', component.options)
    } else {
      api.reload('6db836fe', component.options)
    }
    module.hot.accept("./Common.vue?vue&type=template&id=6db836fe", function () {
      api.rerender('6db836fe', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/settings/sale/Common.vue"
export default component.exports